<template lang="pug">
  .identify-fire-intensity
    section
      .subtitle Draw A Point:
      p Click on the map to determine the potential wildfire intensity within a general vicinity of the location you define. Results are based on high to extreme fire weather conditions.
      .controls
        v-btn(small class="black--text" color="secondary" v-show="!drawing" @click="calculateRisk" style="width: 130px; margin: 3px;")
          v-icon(left style="margin-right: 5px;") edit
          | Draw Point
        v-btn#fireIntensityDrawFinish(small color="primary" dark v-show="drawing" @click="finishDrawing" style="width: 130px; margin: 3px;")
          v-icon(left style="margin-right: 5px;") check_circle
          | Finish drawing
        v-btn(small color="black" dark style="width: 130px; margin: 3px;" @click="clear")
          v-icon(left style="transform: rotate(-45deg); margin-right: 5px;") add_circle
          | Clear Point
    section
      .subtitle
        | Selected Point Location:
        a(href="#" class="primary--text" @click="zoomToPoint") ZOOM TO
      div.latlng
        span
          strong Lat:
          |&nbsp;{{ lonLat[1] }}
        span
          strong Lng:
          |&nbsp;{{ lonLat[0] }}
    section
      .subtitle
        | Your Fire Intensity Rating:
        a(href="https://help.coloradoforestatlas.org/public/identify-fire-intensity" target="_blank" class="primary--text") RESULTS HELP
      v-card.risk-result(v-if="riskdata")
        v-toolbar(:color="'#' + riskdata.color" dense dark flat)
          v-toolbar-title(:style="{ color: '#' + riskdata.fontcolor }") {{ riskdata.label }}
        v-card-text
          .description(v-html="riskdata.description")
          v-btn(color="black" dark block style="font-size: 10px;" href="https://csfs.colostate.edu/wildfire-mitigation/" target="_blank")
            v-icon(style="font-size: 16px; margin-right: 5px;") info
            | LEARN HOW TO REDUCE YOUR RISK
      div(v-else)
        p Please use the “Draw Point” tool to select a point on the map to calculate your wildfire risk.
</template>

<script>
import { unByKey } from "ol/Observable";
import {arcgisIdentifyService, identify} from "../services/identify";
import {
  getMap,
  enableClickToDrawTooltip,
  disableClickToDrawTooltip,
  drawPoint,
  clearPoints,
  zoomToLonLat,
} from "../services/map";
import { toLonLat } from "ol/proj";
export default {
  data() {
    return {
      drawing: false,
      clickevt: null,
      riskdata: null,
      lonLat: [null, null],
      style: null,
    };
  },
  watch: {
    riskdata() {
      if (!this.riskdata) return {};
      return {
        color: this.riskdata.fontcolor,
        backgroundColor: this.riskdata.color,
      };
    },
  },
  methods: {
    async calculateRisk() {
      this.drawing = true;
      enableClickToDrawTooltip();
      this.clickevt = getMap().on("singleclick", async (evt) => {
        this.lonLat = toLonLat(evt.coordinate).map((c) => c.toFixed(6));
        // this.riskdata = await identify(evt);
        this.riskdata = await arcgisIdentifyService({
          geojson: {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: evt.coordinate
            }
          },
          mapExtent: getMap().getView().calculateExtent(),
          imageDisplay: getMap().getSize(),
        })
        drawPoint(evt.coordinate);
      });
    },
    clear() {
      unByKey(this.clickevt);
      this.riskdata = null;
      this.drawing = false;
      this.lonLat = ["", ""];
      disableClickToDrawTooltip();
      clearPoints();
    },
    finishDrawing() {
      unByKey(this.clickevt);
      this.drawing = false;
      disableClickToDrawTooltip();
    },
    zoomToPoint(ev) {
      ev.preventDefault();
      if (this.lonLat.length && this.lonLat[0]) zoomToLonLat(this.lonLat, 5);
    },
  },
};
</script>

<style lang="stylus" scoped>
.identify-fire-intensity
  padding 1em
  font-size 12px
  section
    padding 1em 0
    border-bottom 1px solid #f1f1f1
    &:nth-last-child(1)
      border none
    .subtitle
      font-weight bold
      font-size 13px
      margin-bottom 1em
      display flex
      align-items center
      justify-content space-between
      a
        text-decoration none
        font-size 10px
        cursor pointer
    .latlng
      display flex
      align-items center
      justify-content space-around
</style>
<style lang="stylus">
.identify-fire-intensity
  .risk-result
    .v-toolbar__content
      justify-content center
    .v-toolbar__title
      font-size 18px
  .controls
    .v-btn__content
      font-size .9em
      i
        font-size 1.6em
</style>
